import React, { Component } from 'react';
import _ from 'lodash';
import { Divider } from 'semantic-grab-ui';
import { connect } from 'react-redux';

import { getSegmentName, getSegmentNamespace } from 'components/form/trident-campaigns/constants/utils';
import SegPInsightsWidget from 'components/form/trident-campaigns/SegPInsightsWidget';
import { targetUserTypes } from 'data/trident-types';
import { getCountryPercentageInSegment } from 'omega-rtc/utils/segp-utils';

import { getSegmentUrl } from './campaign-analysis';

type Props = {
  segment: string, // combined segment string
  targetUserType: string, // campaign's target user type
  countryID: int, // campaign's country ID
};

// SegmentDetailDisplay displays the following:
// - the segment name, which links to the segment page
// - a warning text if segment contains too many users not in the campaign's country
// - the segment insights widget
class SegmentDetailDisplay extends Component {
  props: Props;

  constructor(props) {
    super(props);
    this.state = {
      displayWarningMessage: '',
    };
  }

  onSegmentData = (data, countryPercentageWarningThreshold) => {
    if (_.isEmpty(data)) {
      return;
    }

    if (_.isEmpty(_.get(data, 'pax:country.attributes'))) {
      this.setState({
        displayWarningMessage: 'Segment country info not available, there is a chance that this campaign may trigger actions on users outside of the campaign country.',
      });
      return;
    }

    const countryName = _.get(
      _.find(this.props.countries, c => c.countryID === this.props.countryID),
      'name',
    );

    const campaignCountryPercent = getCountryPercentageInSegment(data, countryName);
    const differentCountryPercent = 100 - _.round(campaignCountryPercent, 2);
    if (differentCountryPercent > countryPercentageWarningThreshold) {
      this.setState({
        displayWarningMessage: `WARNING: ${differentCountryPercent}% of the users in this segment are not in the campaign's country!!`,
      });
    }
  }

  render() {
    const { segment, targetUserType, countryPercentageWarningThreshold } = this.props;

    const segmentName = getSegmentName(segment);
    const segmentNamespace = getSegmentNamespace(segment);

    return (
      <div>
        <a href={getSegmentUrl(targetUserType, segmentName)} target="_blank">
          {segmentName}
        </a>
        {
          this.state.displayWarningMessage &&
            <span style={
              {
                backgroundColor: 'red',
                color: 'white',
                padding: '10px 10px',
                marginLeft: 20,
                fontWeight: 'bold',
                position: 'absolute',
                marginTop: -10,
              }
            }
            >
              {this.state.displayWarningMessage}
            </span>
        }
        <p
          style={
            { paddingTop: 20 }
          }
        />
        {
          (targetUserType === targetUserTypes.pax || targetUserType === targetUserTypes.moveITPax) &&
          <SegPInsightsWidget
            segmentID={segmentName}
            namespace={segmentNamespace}
            onDataLoaded={(eventData) => this.onSegmentData(eventData, countryPercentageWarningThreshold)}
          />
        }
        <Divider />
      </div>

    );
  }
}

function mapStateToProps(state: StoreState) {
  return {
    countryPercentageWarningThreshold: _.get(state, 'newTridents.segPConfig.countryPercentageWarningThreshold', 5),
    countries: state.countries.entities,
  };
}

export default connect(mapStateToProps, {})(SegmentDetailDisplay);
